/** Format cents to EUR string */
export function formatPrice(cents: number): string {
  return new Intl.NumberFormat('en-EU', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(cents / 100);
}

/** Format ISO date string to readable format */
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Get display label for product category */
export function categoryLabel(category: string): string {
  const labels: Record<string, string> = {
    'soda': 'Soda',
    'energy': 'Energy',
    'brainstorm': 'Brainstorm',
    'hydrate': 'Hydrate',
    'cold-brew': 'Cold Brew',
  };
  return labels[category] || category;
}

/** Get CSS classes for status badges */
export function statusColor(status: string): string {
  const colors: Record<string, string> = {
    verification_needed: 'bg-violet-100 text-violet-800',
    pending: 'bg-amber-100 text-amber-800',
    confirmed: 'bg-blue-100 text-blue-800',
    packed: 'bg-purple-100 text-purple-800',
    shipped: 'bg-orange-100 text-orange-800',
    delivered: 'bg-emerald-100 text-emerald-800',
    problem: 'bg-red-100 text-red-800',
    open: 'bg-blue-100 text-blue-800',
    'in-progress-l1': 'bg-amber-100 text-amber-800',
    'in-progress-l2': 'bg-orange-100 text-orange-800',
    resolved: 'bg-emerald-100 text-emerald-800',
    closed: 'bg-gray-200 text-gray-600',
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
}

/** Get CSS classes for priority badges */
export function priorityColor(priority: string): string {
  return priority === 'urgent'
    ? 'bg-red-100 text-red-800'
    : 'bg-gray-100 text-gray-700';
}
